export default __webpack_public_path__ + "static/task-050e0ee55d7967e5b14c0ed7464534c7.png";